'use client';

import { Button, Grid, Typography } from '@mui/material';

type Props = {
	error: Error & { digest?: string };
	reset: () => void;
};

export default function GlobalError({ error, reset }: Props) {
	const goToProjects = () => {
		const { origin } = window.location;
		window.location.href = `${origin}/projects`;
	};

	return (
		<Grid
			container
			sx={{
				direction: 'column',
				height: '100vh',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Grid sx={{ alignItems: 'center', mb: 4 }}>
				<Typography variant='h1' sx={{ fontSize: 48, mb: 2 }}>
					Something went wrong
				</Typography>
				{error?.message ? (
					<Typography variant='h2' sx={{ fontSize: 24, textAlign: 'center' }}>
						{error.message}
					</Typography>
				) : null}
			</Grid>
			<Grid sx={{ alignItems: 'center', gap: 2, display: 'flex' }}>
				<Button variant='outlined' onClick={reset}>
					Try again
				</Button>
				<Button variant='contained' onClick={goToProjects}>
					Go to Projects
				</Button>
			</Grid>
		</Grid>
	);
}
